<template>
  <footer
    class="hosting-support-footer"
    :style="{
      background: footerBackground,
      color: theme.text
    }"
  >
    <div class="support-content">
      <span class="support-text">
        {{
          currentLanguage === 'fr'
            ? "Besoin d'aide ? Nous sommes toujours là pour vous."
            : "Need help? We're always here for you."
        }}
      </span>

      <v-btn
        color="teal-darken-1"
        rounded="lg"
        size="small"
        class="support-button text-none"
        @click="goToSupport"
      >
        <v-icon
          start
          size="17"
        >
          mdi-chat
        </v-icon>

        {{
          currentLanguage === 'fr'
            ? 'Accéder au chat en direct'
            : 'Go to Live Chat page'
        }}
      </v-btn>
    </div>
  </footer>
</template>

<script setup>
import {
  computed
} from 'vue'

import {
  useRouter
} from 'vue-router'

import {
  useThemeStore
} from '@/store/auth'

import {
  useLangStore
} from '@/store/lang'

// ============================================================
// STORES
// ============================================================

const themeStore =
  useThemeStore()

const langStore =
  useLangStore()

const router =
  useRouter()

// ============================================================
// THEME
// ============================================================

const theme =
  computed(() =>
    themeStore.themeStyles
  )

/*
 * Keep the light blue/grey hosting footer from the
 * reference while still supporting dark mode.
 */
const footerBackground =
  computed(() => {
    const currentTheme =
      localStorage.getItem(
        'currentTheme'
      )

    if (currentTheme === 'dark') {
      return '#252a2d'
    }

    return '#eef7f8'
  })

// ============================================================
// LANGUAGE
// ============================================================

const currentLanguage =
  computed(() =>
    langStore.currentLanguage ||
    'en'
  )

// ============================================================
// SUPPORT
// ============================================================

const goToSupport = () => {
  /*
   * Replace this with the actual Nexgbits support route
   * once we wire the Help Center / Live Chat page.
   *
   * Example later:
   *
   * router.push({
   *   name: 'HostingSupport',
   *   params: {
   *     lang: currentLanguage.value
   *   }
   * })
   */

  console.log(
    'Open Nexgbits Hosting live support'
  )
}
</script>

<style scoped>
.hosting-support-footer {
  width: 100%;

  min-height: 70px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding:
    14px
    20px;

  border-top:
    1px solid
    rgba(0, 0, 0, 0.04);
}

.support-content {
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 14px;
}

.support-text {
  font-size: 12px;
  font-weight: 600;

  white-space: nowrap;
}

.support-button {
  min-height: 32px;

  padding-left: 14px;
  padding-right: 14px;

  font-size: 12px;
  font-weight: 600;
}

/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 600px) {
  .hosting-support-footer {
    padding:
      14px
      12px;
  }

  .support-content {
    flex-direction: column;

    gap: 9px;

    text-align: center;
  }

  .support-text {
    white-space: normal;

    font-size: 11px;
  }
}
</style>